import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectOrderFlagsGroupName } from '../state/selectors/orderFlags';

export type FlagScopeTexts = {
  /** Título y texto accesible de la cabecera de la columna. */
  header: string;
  /** Nombre accesible del botón de la fila. */
  toggle: string;
  /** Etiqueta del filtro «Solo importantes». */
  onlyFlagged: string;
};

/**
 * Textos de las banderitas según el ámbito: si el usuario está en un grupo
 * (las marcas son del grupo) nombran el grupo; si no, son los de siempre.
 */
export function useFlagScopeTexts(): FlagScopeTexts {
  const { t } = useTranslation(['common']);
  const group = useSelector(selectOrderFlagsGroupName);

  if (group) {
    return {
      header: t('common:tables.flag.headerGroup', { group }),
      toggle: t('common:tables.flag.toggleGroup', { group }),
      onlyFlagged: t('common:tables.flag.onlyFlaggedGroup', { group }),
    };
  }
  return {
    header: t('common:tables.headers.flag'),
    toggle: t('common:tables.flag.toggle'),
    onlyFlagged: t('common:tables.flag.onlyFlagged'),
  };
}
